import React from 'react';
import HomeButton from './common/HomeButton';

export const TOS_CURRENT_VERSION = '2020-05-01';

const TOS = () => (
  <>
    <HomeButton />
    <div className='tos'>
      <div className='tos-card'>
        <h2>This is NOT a final product.</h2>
        <p>
          Use service (Backroom) at your own risk. The creators and maintainers of this service
          offer no warrany whatsoever for anything.
        </p>
        <h2>Privacy Policy</h2>
        <p>The effective date of this policy is May 1st, 2020 (Version {TOS_CURRENT_VERSION}).</p>
        <p>
          Backroom may collect and store your email address, your name and your profile image
          information.
        </p>
        <p>
          You may provide us with your contact information, whether through our the use of Backroom
          app, login forms, an interaction with an identity provider. Backroom collects the
          information provided by you or such provider. Collected information includes first name,
          last name, email and phone number.
        </p>
        <p>
          Backroom will collect information from the device and application you use to access our
          services. Device data means your IP address, operating system version, device types,
          system and performance information, and browser version.
        </p>
        <p>
          We use third party tracking services that employ cookies, page tags (web beacons) to
          collect data about our visitors and users.
        </p>
        <p>
          Personal information name and profile image will be used to identify your participation in
          Backroom.
        </p>
        <p>
          Your email can be used for notificatify about Backroom, as well for marketing of events
          related to content you've interacted with using Backroom.
        </p>
        <p>
          Backroom will collect usage of all of its applications, included but not limited to the
          Web client and Mobile Applications.
        </p>
        <p>
          This experimental service (Backroom) does not include any barriers or warranties for the
          information your video and audio broadcast during the usage of Backroom. Your broadcast is
          not protected and could be accessed by third parties, either present in the events you
          join or not. The creators and maintainers of Backroom cannot ensure the protection of
          anything you broadcast (video or audio).
        </p>
        <p>
          Backroom can only be used my adults, aged 18 or older within the United States of America.
          For other countries, its usage is limited to adult age in their territory. If you are not
          an adult, aged 18 or older, you must stop using our Services.
        </p>
        <p>
          Usage of Backroom by minors, or to share information about minors, is strictly forbidden.
        </p>
        <p>
          We may amend our Privacy Policy. We will provide you notice of amedments to this Privacy
          Policy, as appropriate, and update the "Last Modified" date at the top of this Privacy
          Policy. Your continued use of Backroom confirms your acceptance of our Privacy Policy, as
          amended. If you do not agree with your Privacy Policy, as amended, you must stop using our
          Services. Please review our Privacy Policy from time to time.
        </p>
        <p>
          To request deletion of your data, please email support@backroom.social using the email
          address that you used to sign up and include your name.
        </p>
      </div>
    </div>
  </>
);

export default TOS;
